<div class="row align-items-start mb-4">
    <div class="col-auto">
        <app-back-button></app-back-button>
    </div>
    <div class="col-auto mx-auto">
        <h5>{{ "PAGES.CATEGORY-DETAILS" | translate }}</h5>
    </div>
    <div class="col-auto" style="width: 120px"></div>
</div>
<div [nbSpinner]="loading" style="min-height: 200px; background: white" class="p-4">
    <ng-container *ngIf="tournament">
        <p class="text-caption mb-0">
            {{ tournament.detail.nome_torneio }}
        </p>
        <h1 class="h-tournament-title h2">{{ category.descricao }}</h1>
        <nb-tabset fullWidth>
            <nb-tab tabTitle="{{ 'GENERAL.GAMES' | translate }}" tabIcon="flag-outline" responsive>
                <app-tab-games [tournamentId]="tournamentId" [categoryId]="categoryId"></app-tab-games>
            </nb-tab>
            <nb-tab tabTitle="{{ 'GENERAL.SUBSCRIPTIONS' | translate }}" tabIcon="people-outline" responsive>
                <app-tab-enrollments [tournamentId]="tournamentId" [categoryId]="categoryId"></app-tab-enrollments>
            </nb-tab>

            <nb-tab tabTitle="{{ 'GENERAL.CLASSIFICATION' | translate }}" tabIcon="trending-up-outline" responsive>
                <app-tab-classification
                    [tournamentId]="tournamentId"
                    [categoryId]="categoryId"
                ></app-tab-classification>
            </nb-tab>
            <nb-tab tabTitle="{{ 'GENERAL.PROGRAMMING' | translate }}" tabIcon="clock-outline" responsive>
                <app-tab-matchs [tournamentId]="tournamentId"></app-tab-matchs>
            </nb-tab>
        </nb-tabset>
    </ng-container>
</div>
